import React from 'react'
import { TitleAniLeft } from '../../component/ScrollTest'
import { useLanguage } from '../../i18n/LanguageContext'

const WORKS = {
  ja: [
    {
      url: 'https://lmspiq.fda.gov.tw/web/',
      img: 'fdaLicense.png',
      alt: '許可証照会サイト',
      title: '許可証照会サイト',
      items: [
        'アーキテクチャ設計を担当',
        '一部ページの実装に参加',
        'ウェブアクセシビリティ AA 等級に対応するよう改修',
      ],
    },
    {
      url: 'https://b2bfundrwdtest.moneydj.com/nextfundetf/fund/demo',
      img: 'fundEtf.png',
      alt: 'ファンド・ETF情報サイト',
      title: 'ファンド・ETF情報サイト',
      items: [
        '同僚1名と共同で開発を担当',
        'コード全体はAIが生成し、私たちはAIと設計・アーキテクチャについて議論する役割を担当',
      ],
    },
    {
      url: 'https://makosweather.netlify.app',
      img: 'weather.png',
      alt: '天気検索',
      title: '気象ダッシュボード',
      items: [
        '台湾各地の天気を検索可能',
        'ライト／ダークモード切り替え対応',
        'RWD対応',
      ],
    },
    {
      url: 'https://makos-music.netlify.app',
      img: 'music.png',
      alt: '音楽再生',
      title: '音楽再生サイト',
      items: [
        '曲のリピート再生や、好きな曲を選んで再生可能',
        'VBSのファンとして、楽しみながら制作しました',
        { type: 'demo', label: 'Electronデスクトップアプリ版はこちらからダウンロード', url: 'https://drive.google.com/file/d/1iWn7DwnGyAvPs7hOmEMXFZhazPeEyA4Q/view?usp=sharing' },
      ],
    },
    {
      url: 'https://makostodolist.netlify.app',
      img: 'todo.png',
      alt: 'タスク管理',
      title: 'タスク管理アプリ',
      items: [
        'MUIを使用して制作',
      ],
    },
    {
      url: 'https://makovcafe.netlify.app/',
      img: 'vCafe.png',
      alt: 'カフェサイト',
      title: 'カフェサイト',
      items: [
        'React+TypeScriptを使用して制作',
      ],
    },
  ],
  zh: [
    {
      url: 'https://lmspiq.fda.gov.tw/web/',
      img: 'fdaLicense.png',
      alt: '許可證查詢網',
      title: '許可證查詢網',
      items: [
        '負責定下架構',
        '參與部分頁面製作',
        '將其修改成無障礙網頁AA級',
      ],
    },
    {
      url: 'https://b2bfundrwdtest.moneydj.com/nextfundetf/fund/demo',
      img: 'fundEtf.png',
      alt: '基金與ETF資訊網',
      title: '基金與ETF資訊網',
      items: [
        '由我跟另一位同事一起負責製作',
        '整體程式碼由AI負責，我們負責跟AI討論設計以及架構',
      ],
    },
    {
      url: 'https://makosweather.netlify.app',
      img: 'weather.png',
      alt: '天氣查詢',
      title: '氣象儀錶板',
      items: [
        '可以查詢台灣各地天氣',
        '切換亮色/暗色',
        '有RWD',
      ],
    },
    {
      url: 'https://makos-music.netlify.app',
      img: 'music.png',
      alt: '音樂播放',
      title: '音樂播放網站',
      items: [
        '可以循環播放或點擊播放任意歌曲',
        '身為VBS粉絲，做得很快樂',
        { type: 'demo', label: 'electron 桌面應用版點此下載', url: 'https://drive.google.com/file/d/1iWn7DwnGyAvPs7hOmEMXFZhazPeEyA4Q/view?usp=sharing' },
      ],
    },
    {
      url: 'https://makostodolist.netlify.app',
      img: 'todo.png',
      alt: '待辦清單',
      title: '待辦清單',
      items: [
        '使用MUI製作',
      ],
    },
    {
      url: 'https://makovcafe.netlify.app/',
      img: 'vCafe.png',
      alt: '咖啡廳網站',
      title: '咖啡廳網站',
      items: [
        '使用React+TypeScript製作',
      ],
    },
  ],
}

const IMAGES = {
  'fdaLicense.png': require('../../assets/img/fdaLicense.png'),
  'fundEtf.png': require('../../assets/img/fundEtf.png'),
  'weather.png': require('../../assets/img/weather.png'),
  'music.png': require('../../assets/img/music.png'),
  'todo.png': require('../../assets/img/todo.png'),
  'vCafe.png': require('../../assets/img/vCafe.png'),
}

function renderWorkItem(item, key) {
  if (item && typeof item === 'object' && item.type === 'demo') {
    return (
      <li
        key={key}
        onClick={(e) => { e.stopPropagation(); window.open(item.url, '_blank') }}
        style={{ cursor: 'pointer', color: '#833ab4' }}
      >
        {item.label}
      </li>
    )
  }
  return <li key={key}>{item}</li>
}

export default function Works() {
  const { lang } = useLanguage()
  const works = WORKS[lang]
  return (
    <div>
        <section className="work" id="work">
            <TitleAniLeft title='My' title2='works'/>
            <br/>
            <div className='box-container'>
                {works.map((work, index) => (
                  <div className='box' key={index} onClick={()=>window.open(work.url, '_blank')}>
                      <img className='workImg' src={IMAGES[work.img]} alt={work.alt}/>
                      <p>{work.title}</p>
                      <ul>
                          {work.items.map((item, i) => renderWorkItem(item, i))}
                      </ul>
                  </div>
                ))}
            </div>
        </section>
    </div>
  )
}
